import Vue from "vue";
import Modal from "./modal.vue";
// import Button from "../button/button.vue";
import { Button } from "view-design";
// import Locale from "../../mixins/locale";

const prefixCls = "ivu-modal-confirm";

Modal.newInstance = properties => {
  const _props = properties || {};
  // console.log(_props);
  const Instance = new Vue({
    data: Object.assign({}, _props, {
      visible: false,
      width: 416,
      title: "",
      body: "",
      iconType: "",
      iconName: "",
      btnType: "primary",
      okText: undefined,
      cancelText: undefined,
      showCancel: false,
      loading: false,
      buttonLoading: false,
      scrollable: false,
      closable: false,
      allowClosed: true, //允许关闭,false要手动关闭
      closing: false // 关闭有动画，期间使用此属性避免重复点击
    }),
    render(h) {
      // console.log(_props);
      // let footerVNodes = [];
      // if (this.showCancel) {
      //   footerVNodes.push(
      //     h(
      //       Button,
      //       {
      //         props: {
      //           type: "text",
      //           size: "large"
      //         },
      //         on: {
      //           click: this.cancel
      //         }
      //       },
      //       this.localeCancelText
      //     )
      //   );
      // }
      // footerVNodes.push(
      //   h(
      //     Button,
      //     {
      //       props: {
      //         type: "primary",
      //         size: "large",
      //         loading: this.buttonLoading
      //       },
      //       on: {
      //         click: this.ok
      //       }
      //     },
      //     this.localeOkText
      //   )
      // );
      //render footer
      let footerVNodes = [];
      // console.log(this.otherText);
      if (this.otherText) {
        footerVNodes.push(
          h(
            Button,
            {
              class: ["u-modal-btn"],
              props: {
                size: "large"
              },
              on: {
                click: this.otherFn
              }
            },
            this.otherText
          )
        );
      }
      footerVNodes.push(
        h(
          Button,
          {
            class: ["u-modal-btn"],
            props: {
              type: this.btnType,
              size: "large",
              loading: this.buttonLoading
            },
            on: {
              click: this.ok
            }
          },
          this.localeOkText
        )
      );
      if (this.showCancel) {
        footerVNodes.push(
          h(
            Button,
            {
              class: ["u-modal-btn"],
              props: {
                size: "large"
              },
              on: {
                click: this.cancel
              }
            },
            this.localeCancelText
          )
        );
      }
      // render content
      let body_render;
      if (this.render) {
        body_render = h(
          "div",
          {
            attrs: {
              class: `${prefixCls}-body ${prefixCls}-body-render`
            }
          },
          [this.render(h)]
        );
      } else {
        body_render = h(
          "div",
          {
            attrs: {
              class: `${prefixCls}-body`
            }
          },
          [
            h("div", {
              domProps: {
                innerHTML: this.body
              }
            })
          ]
        );
      }

      // when render with no title, hide head
      // let head_render;
      // if (this.title) {
      //   head_render = h(
      //     "div",
      //     {
      //       attrs: {
      //         class: `${prefixCls}-head`
      //       }
      //     },
      //     [
      //       // h(
      //       //   "div",
      //       //   {
      //       //     class: this.iconTypeCls
      //       //   },
      //       //   [
      //       //     h("i", {
      //       //       class: this.iconNameCls
      //       //     })
      //       //   ]
      //       // ),
      //       h("div", {
      //         attrs: {
      //           class: `${prefixCls}-head-title`
      //         },
      //         domProps: {
      //           innerHTML: this.title
      //         }
      //       })
      //     ]
      //   );
      // }
      // console.log(_props);
      return h(
        Modal,
        {
          props: Object.assign({}, _props, {
            width: this.width,
            scrollable: this.scrollable,
            closable: this.closable,
            title: this.title
          }),
          domProps: {
            value: this.visible
          },
          on: {
            input: status => {
              this.visible = status;
            },
            "on-cancel": this.cancel
          }
        },
        [
          h(
            "div",
            {
              attrs: {
                class: prefixCls
              }
            },
            [
              // head_render,
              body_render,
              // footer_render
              h(
                "div",
                {
                  class: [`${prefixCls}-footer`, "ivu-modal-footer"]
                  // attrs: {
                  //   class: `${prefixCls}-footer`
                  // },
                  // style: {
                  //   textAlign: "center"
                  // }
                },
                footerVNodes
              )
            ]
          )
        ]
      );
    },
    computed: {
      // iconTypeCls() {
      //   return [
      //     `${prefixCls}-head-icon`,
      //     `${prefixCls}-head-icon-${this.iconType}`
      //   ];
      // },
      // iconNameCls() {
      //   return ["ivu-icon", `ivu-icon-${this.iconName}`];
      // },
      localeOkText() {
        if (this.okText) {
          return this.okText;
        } else {
          return "确定";
        }
      },
      localeCancelText() {
        if (this.cancelText) {
          return this.cancelText;
        } else {
          return "取消";
        }
      }
    },
    methods: {
      otherFn() {
        //如果返回false, 就阻止关闭对话框
        let closed = this.onOther();
        if (typeof closed === "undefined") {
          this.cancel();
        }
      },
      cancel() {
        // console.log("cancel");
        if (this.closing) return;
        this.$children[0].visible = false;
        this.buttonLoading = false;
        this.onCancel();
        this.remove();
      },
      ok() {
        this.onOk();
        if (!this.allowClosed) return;
        if (this.closing) return;
        if (this.loading) {
          this.buttonLoading = true;
        } else {
          this.$children[0].visible = false;
          this.remove();
        }
        // this.onOk();
      },
      remove() {
        this.closing = true;
        setTimeout(() => {
          this.closing = false;
          this.destroy();
        }, 300);
      },
      destroy() {
        this.$destroy();
        document.body.removeChild(this.$el);
        this.onRemove();
      },
      onOther() {},
      onOk() {},
      onCancel() {},
      onRemove() {}
    }
  });

  const component = Instance.$mount();
  document.body.appendChild(component.$el);
  const modal = Instance.$children[0];

  return {
    show(props) {
      // console.log(modal);
      modal.$parent.showCancel = props.showCancel;
      if ("width" in props) {
        modal.$parent.width = props.width;
      }

      if ("closable" in props) {
        modal.$parent.closable = props.closable;
      }
      if ("btnType" in props) {
        modal.$parent.btnType = props.btnType;
      }

      if ("title" in props) {
        modal.$parent.title = props.title;
      }

      if ("content" in props) {
        modal.$parent.body = props.content;
      }

      if ("okText" in props) {
        modal.$parent.okText = props.okText;
      }

      if ("cancelText" in props) {
        modal.$parent.cancelText = props.cancelText;
      }

      if ("onCancel" in props) {
        modal.$parent.onCancel = props.onCancel;
      }

      if ("onOk" in props) {
        modal.$parent.onOk = props.onOk;
      }
      if ("onOther" in props) {
        modal.$parent.onOther = props.onOther;
      }
      // async for ok
      if ("loading" in props) {
        modal.$parent.loading = props.loading;
      }

      if ("scrollable" in props) {
        modal.$parent.scrollable = props.scrollable;
      }
      if ("allowClosed" in props) {
        modal.$parent.allowClosed = props.allowClosed;
      }
      // notice when component destroy
      modal.$parent.onRemove = props.onRemove;

      modal.visible = true;
    },
    remove() {
      // console.log("移除组件");
      modal.visible = false;
      modal.$parent.buttonLoading = false;
      modal.$parent.remove();
    },
    component: modal
  };
};

export default Modal;
